// Sidebar Menu Widget: adapt to existing Dropdown component structure and toggle by click
// Transforms .widget_nav_menu li.menu-item-has-children into .dropdown wrappers
(function () {
	function wrapDropdown(item) {
		var link = item.querySelector(':scope > a');
		var subMenu = item.querySelector(':scope > .sub-menu');
		if (!link || !subMenu) return;

		// Create dropdown wrapper
		var wrapper = document.createElement('div');
		wrapper.className = 'dropdown js-dropdown dropdown--sidebar';

		// Create trigger button (separate from the link to avoid hijacking navigation)
		var trigger = document.createElement('button');
		trigger.type = 'button';
		trigger.className = 'dropdown__trigger js-dropdown__trigger';
		trigger.setAttribute('aria-expanded', 'false');
		trigger.setAttribute('aria-label', link.textContent ? link.textContent.trim() : 'Open submenu');
		trigger.innerHTML =
			'<svg class="icon" viewBox="0 0 16 16" aria-hidden="true">' +
			'<polyline fill="none" stroke-width="2" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="3.5,6.5 8,11 12.5,6.5 "></polyline>' +
			'</svg>';

		// Prepare menu container using existing subMenu
		subMenu.classList.add('dropdown__menu', 'js-dropdown__menu');
		// Ensure submenu links have dropdown item class
		subMenu.querySelectorAll('a').forEach(function (a) {
			a.classList.add('dropdown__item');
		});

		// Insert structure: keep original link, add trigger, then submenu as dropdown__menu
		link.after(trigger);
		item.insertBefore(wrapper, link);
		wrapper.appendChild(link); // link remains first
		wrapper.appendChild(trigger);
		wrapper.appendChild(subMenu);

		// Click toggle (use class toggling, independent from hover-based Dropdown)
		trigger.addEventListener('click', function (e) {
			e.preventDefault();
			var isOpen = wrapper.classList.contains('is-open');
			wrapper.classList.toggle('is-open', !isOpen);
			trigger.setAttribute('aria-expanded', String(!isOpen));
			subMenu.classList.toggle('dropdown__menu--is-visible', !isOpen);
			subMenu.classList.toggle('dropdown__menu--hide', isOpen);
		});
	}

	function initSidebarDropdown(widget) {
		var items = widget.querySelectorAll('.menu-item-has-children');
		if (!items.length) return;
		items.forEach(wrapDropdown);
	}

	function init() {
		var widgets = document.querySelectorAll('.widget_nav_menu');
		if (!widgets.length) return;
		widgets.forEach(initSidebarDropdown);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();


